import React, { Component } from "react";
import { Link } from "react-router-dom";

class ContentBlog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      itemsPerPage: 10,
    };
  }
  render() {
    const { page, itemsPerPage } = this.state;
    const { newsList, type } = this.props;

    return newsList ? (
      <div id="site-content" className="site-content clearfix">
        <div id="inner-content" className="inner-content-wrap">
          {newsList
            .slice(page * itemsPerPage, (page + 1) * itemsPerPage)
            .map((data) => {
              const url = `/news?ID=${data.ID}&name=${data.title.replaceAll(
                " ",
                "-"
              )}&type=${type}`;
              return (
                <article className={data.aritcles} key={data.id}>
                  <div
                    className={data.classnames}
                    style={{
                      height: "350px",
                      background: `url(${data.srcimg})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center center",
                    }}
                  >
                    <div className="post-calendar">
                      <span className="inner">
                        <span
                          className="entry-calendar"
                          style={{ background: "silver" }}
                        >
                          <span className="day">{data.day}</span>
                          <span
                            className="month"
                            style={{ textTransform: "uppercase" }}
                          >
                            {data.month}
                          </span>
                        </span>
                      </span>
                    </div>
                    <div className="overlay-effect bg-color-1" />
                  </div>
                  <div className="post-content-wrap clearfix">
                    <h2 className="post-title">
                      <span className="post-title-inner">
                        <a href={url}>{data.title}</a>
                      </span>
                    </h2>
                    <div className="post-meta">
                      <div className="post-meta-content">
                        <div className="post-meta-content-inner">
                          <span className="post-date item">
                            <span className="inner">
                              <span className="entry-date">{data.date}</span>
                            </span>
                          </span>
                          <span className="post-by-author item">
                            <span className="inner">By: {data.author}</span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="post-content post-excerpt">
                      <p>{data.shortContent}</p>
                    </div>
                    <div className="post-read-more">
                      <div className="post-link">
                        <a href={url}>READ MORE</a>
                      </div>
                    </div>
                  </div>
                </article>
              );
            })}
          <div className="themesflat-pagination clearfix">
            <ul>
              <li>
                <Link
                  onClick={() => {
                    this.setState({ page: Math.max(0, page - 1) });
                  }}
                  to="#"
                  className="page-numbers prev"
                >
                  <span className="fa fa-angle-left" />
                </Link>
              </li>
              {[...Array(Math.ceil(newsList.length / itemsPerPage)).keys()].map(
                (i) => (
                  <li>
                    <Link
                      to="#"
                      onClick={() => this.setState({ page: i })}
                      className={`page-numbers ${i === page ? "current" : ""}`}
                    >
                      {i + 1}
                    </Link>
                  </li>
                )
              )}
              <li>
                <Link
                  onClick={() => {
                    this.setState({
                      page: Math.min(
                        Math.ceil(newsList.length / itemsPerPage) - 1,
                        page + 1
                      ),
                    });
                  }}
                  to="#"
                  className="page-numbers next"
                >
                  <span className="fa fa-angle-right" />
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div
          className="themesflat-spacer clearfix"
          data-desktop={80}
          data-mobile={60}
          data-smobile={60}
        />
      </div>
    ) : (
      <div />
    );
  }
}

export default ContentBlog;
